import { AuthServiceInterface } from '@freelancer/auth';
import { updateProjectViewProjectBidStats } from '@freelancer/datastore/collections';
import { DatastoreInterface } from '@freelancer/datastore/core';
import { peopleWithSurnames } from '@freelancer/datastore/testing';
import { ContextTypeApi } from 'api-typings/messages/messages_types';
import { ProjectTypeApi } from 'api-typings/projects/projects';
import {
  createBanners,
  createBids,
  createContestBudgetRanges,
  createCurrencies,
  createDomain,
  createFreelancerReputations,
  createLanguage,
  createMessage,
  createNotificationsPreferences,
  createOnlineOffline,
  createProjectBudgetOptions,
  createProjectUpgradeFee,
  createProjectViewBids,
  createProjectViewProject,
  createProjectViewUsers,
  createReferralInvitationCheck,
  createSiteStat,
  createSkills,
  createThread,
  createUser,
  createUserBalances,
  createUserCalifornianStatuses,
  createUserGiveGetDetail,
  createUserInfo,
  createUserRecentProjectsAndContests,
  createUsers,
  createUsersSelf,
} from './document-creators';

export async function constructInitialStoreState(
  auth: AuthServiceInterface,
  datastore: DatastoreInterface,
  authUid: number,
) {
  // Create self and other me things
  const { id: userId, username } = await createUsersSelf({
    userId: authUid,
  });
  const user = await createUser({ userId });

  // Used on the webapp playground
  await createUser({ userId: 13223 });
  await createUser({ userId: 133223 });

  await createUserInfo({ userId });
  await createUserGiveGetDetail({ userId, username });
  await createUserCalifornianStatuses({ userIds: [userId] });
  await createUserBalances();
  await createBanners();
  await createReferralInvitationCheck({ userId });
  await createNotificationsPreferences();

  // Create project for PVP
  const project = await createProjectViewProject({
    projectId: 42,
    ownerId: userId,
  });
  const { id: projectId } = project;
  await createProjectUpgradeFee({ projectId });
  const bidders = await createUsers({ names: peopleWithSurnames });
  await createProjectViewUsers({
    users: [user, ...bidders],
  });

  const bidderIds = bidders.map((bidder: any) => bidder.id);
  const bids = await createBids({
    bidderIds,
    projectId,
    projectOwnerId: userId,
    minAmount: 100,
    maxAmount: 200,
  });
  await createProjectViewBids({ bids });
  await updateProjectViewProjectBidStats(datastore, { projectId, bids });
  await createFreelancerReputations({ freelancerIds: bidderIds });
  await createOnlineOffline({ userIds: bidderIds });

  // Put project in nav
  await createUserRecentProjectsAndContests({ projects: [project] });

  // Create for PJP
  await createProjectBudgetOptions({
    projectType: ProjectTypeApi.FIXED,
  });
  await createProjectBudgetOptions({
    projectType: ProjectTypeApi.HOURLY,
  });
  await createContestBudgetRanges();

  // Create global things
  await createSiteStat({ userId });
  await createLanguage();
  await createDomain();
  await createCurrencies();
  await createSkills();
  const thread = await createThread({
    userId: authUid,
    otherMembers: bidderIds,
    context: { type: ContextTypeApi.PROJECT, id: project.id },
  });
  await createMessage({
    fromUserId: authUid,
    thread,
    bid: bids[0],
  });
}
